import { theme } from "antd";
import { ReactElement } from "react";
import CenterContent from "../layouts/CenterContent";
import FullScreenSpinner from "./FullScreenSpinner";

const AuthenticatingScreen = (): ReactElement => {
  const { token } = theme.useToken();

  return (
    <CenterContent $backgroundColor={token.colorBgContainer} $color={token.colorText} $padding={token.padding}>
      <FullScreenSpinner tip="Authenticating..." />
    </CenterContent>
  );
};

export default AuthenticatingScreen;
